<template>
  <div class="cc-header header">
    <input type="hidden" id="goback" value="4" />
    <cc-svg-icon @click="goback" icon-class='left-arrow' class-name='left-arrow' size=".2rem"></cc-svg-icon>
    <!-- <a @click="goback" class="backward">返回</a> -->
    <p class="cc-header-title">{{ title }}</p>
    <div class="cc-header-right">
      <slot name="right">

      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cc-header',
  props: {
    title: {
      type: String,
      default: ''
    },
    // 跳转的url
    url: {
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    goback () {
      if (this.url) {
        window.location = this.url
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
.cc-header {
  position: static;
  height: $titleHeight;
  @include flex(row);
  align-items: center;
  .left-arrow {
    padding: 10px;
    color:#fff;
    width: 20px;
    height: 20px;
  }
  &-title {
    flex: 1;
    font-size: 16px;
    text-align: center;
  }
  &-right {
    box-sizing: border-box;
    padding: 0 10px;
  }
}
</style>
